/*
 *
 * App reducer
 *
 */
import produce from 'immer';
import { LOGIN_USER_SUCCESS } from 'ui/containers/LoginPage/constants';
import { CHANGE_CURRENT_PROJECT_SUCCESS, GET_TEAMS_ONLY_TOKEN } from './constants';

export const initialState = {
  loading: false,
  error: false,
  user: {
    token: false,
    isAuthenticated: false, // check if user has token
  },
  currentProject: {
    projectName: null,
  },
};

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) => {
  const data = action.payload && action.payload.data;

  return produce(state, draft => {
    switch (action.type) {
      case LOGIN_USER_SUCCESS:
        draft.user.token = data && data.token;
        draft.user.isAuthenticated = data && !!data.token;
        break;

      case CHANGE_CURRENT_PROJECT_SUCCESS:
        draft.currentProject.projectName = data && data.name;
        break;
      case GET_TEAMS_ONLY_TOKEN.START:
        draft.loading = true;
        draft.error = false;
        break;
      case GET_TEAMS_ONLY_TOKEN.SUCCESS:
        draft.user.token = data && data.token;
        draft.user.isAuthenticated = data && !!data.token;
        draft.loading = false;
        draft.error = false;
        break;
      case GET_TEAMS_ONLY_TOKEN.ERROR:
        draft.loading = false;
        draft.error = true;
        break;
    }
  });
};

export default appReducer;
